/**
 * Table format border
 */
// eslint-disable-next-line etc/no-const-enum
export var TableBorderFormat;
(function (TableBorderFormat) {
    /**
     * All border of the table are displayed
     *  __ __ __
     * |__|__|__|
     * |__|__|__|
     * |__|__|__|
     */
    TableBorderFormat[TableBorderFormat["DEFAULT"] = 0] = "DEFAULT";
    /**
     * Middle vertical border are not displayed
     *  __ __ __
     * |__ __ __|
     * |__ __ __|
     * |__ __ __|
     */
    TableBorderFormat[TableBorderFormat["LIST_WITH_SIDE_BORDERS"] = 1] = "LIST_WITH_SIDE_BORDERS";
    /**
     * All borders except header rows borders are displayed
     *  __ __ __
     *  __|__|__
     *  __|__|__
     */
    TableBorderFormat[TableBorderFormat["NO_HEADER_BORDERS"] = 2] = "NO_HEADER_BORDERS";
    /**
     * The left and right border of the table are not displayed
     *  __ __ __
     *  __|__|__
     *  __|__|__
     *  __|__|__
     */
    TableBorderFormat[TableBorderFormat["NO_SIDE_BORDERS"] = 3] = "NO_SIDE_BORDERS";
    /**
     * Only the borders that divides the header row, first column and externals are displayed
     *  __ __ __
     * |__ __ __|
     * |  |     |
     * |__|__ __|
     */
    TableBorderFormat[TableBorderFormat["FIRST_COLUMN_HEADER_EXTERNAL"] = 4] = "FIRST_COLUMN_HEADER_EXTERNAL";
    /**
     * The header row has no vertical border, except for the first one
     * The first column has no horizontal border, except for the first one
     *  __ __ __
     * |__ __ __
     * |  |__|__|
     * |  |__|__|
     */
    TableBorderFormat[TableBorderFormat["ESPECIAL_TYPE_1"] = 5] = "ESPECIAL_TYPE_1";
    /**
     * The header row has no vertical border, except for the first one
     * The only horizontal border of the table is the top and bottom of header row
     *  __ __ __
     * |__ __ __
     * |  |     |
     * |  |     |
     */
    TableBorderFormat[TableBorderFormat["ESPECIAL_TYPE_2"] = 6] = "ESPECIAL_TYPE_2";
    /**
     * The only borders are the bottom of header row and the right border of first column
     *  __ __ __
     *    |
     *    |
     */
    TableBorderFormat[TableBorderFormat["ESPECIAL_TYPE_3"] = 7] = "ESPECIAL_TYPE_3";
    /**
     * No border
     */
    TableBorderFormat[TableBorderFormat["CLEAR"] = 8] = "CLEAR";
})(TableBorderFormat || (TableBorderFormat = {}));
//# sourceMappingURL=TableBorderFormat.js.map